module.exports = __webpack_public_path__ + "static/media/salary.b9f00e6a.png";